
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { DateFormScreen } from "../inputs/DateFormScreen";
import { startSavingCentros } from "../../../services";

import Swal from "sweetalert2";



export const FormCreateUpdateCentro = ({ initialState }) => {

    const { id } = useParams();
    const queryClient = useQueryClient();
    const [formCentro, setFormCentro] = useState( initialState );
    const { nombre, fechaCreacion } = formCentro;

    
    const  handleInputChange = ({ target }) => {
        setFormCentro({
            ...formCentro,
            [target.name]: target.value
        });
    }


    const crearActInformacion = async(e) => {
        e.preventDefault();
        const isUpdate = (id !== 'new') ? id : false;

        if([nombre, fechaCreacion].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }

        const result = await Swal.fire({
            title: `${(isUpdate) ? 'Actualizar' : 'Crear'} Centro Costo`,
            text: `¿Esta seguro de ${(isUpdate) ? 'Actualizar' : 'Crear'} Centro Costo?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });
        if (!result.isConfirmed) return;

        const resp = await startSavingCentros({ ...formCentro, id:isUpdate });
        if(resp){
            if(!isUpdate) { 
                setFormCentro({nombre: '', fechaCreacion: null}); 
            }else {
                queryClient.invalidateQueries({queryKey: ['centro-id']});
            }
            queryClient.invalidateQueries({queryKey: ['list-cencos']});
        }
    }


    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre'
                        type='text'
                        placeholder='Nombre'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DateFormScreen
                        size='normal'
                        label="Fecha de Centro" 
                        placeholder='Fecha de Centro' 
                        value={fechaCreacion} 
                        onChange={ handleInputChange } 
                        name='fechaCreacion'
                    />
                </Grid>

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${(id != 'new') ? 'Actualizar' : 'Crear'} Centro Costo`}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
